import tw from "twin.macro"
import { H4, IntroBody } from "styles/Text"
import Section from "components/Section"

import { TextBlockParagraphProps } from "components/dynamic"
import Language from "components/Language"

const TextBlockParagraph = (props: TextBlockParagraphProps) => {
  const { Anchor, Title, Topic, Body } = props
  return (
    <Section anchor={Anchor}>
      <div tw="text-dark-grey">
        {Title && (
          <H4 as="h2" tw="text-black">
            <Language unwrap>{Title}</Language>
          </H4>
        )}
        {Topic && (
          <IntroBody tw="mt-7.5">
            <Language unwrap>{Topic}</Language>
          </IntroBody>
        )}
        {Body && (
          <Language css={Topic ? tw`mt-7.5` : tw`mt-5`}>{Body}</Language>
        )}
      </div>
    </Section>
  )
}

export default TextBlockParagraph
